import { Accept } from 'components/Accept/Accept';
import { NOOP } from 'constants/actions';
import { useTranslations } from 'utils';
import { ReactComponent as CouponIcon } from './assets/ico-coupon.svg';
import './Coupon.scss';

interface CouponProps {
  checked?: boolean;
  onChange?: () => void;
}

export function Coupon({ checked = false, onChange = NOOP }: CouponProps) {
  const i18n = useTranslations();

  return (
    <div className="Coupon-container">
      <Accept
        name="checkbox-coupon"
        data-testid="checkbox-coupon"
        className="Coupon-accpet-container"
        checked={checked}
        onChange={onChange}
      >
        {i18n.t('coupon.havePromoCode.title')}
        <CouponIcon className="Coupon-icon" />
      </Accept>
      {checked && (
        <div className="Coupon-description">
          <span>{i18n.t('coupon.havePromoCode.description')}</span>
        </div>
      )}
    </div>
  );
}
